const IMAGE_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/webp",
  "image/gif",
];

const DOCUMENT_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const IMAGE_AND_DOCUMENT_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
  ".pdf",
  ".doc",
  ".docx",
];

const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp", ".gif"];
const IMAGE_AND_PDF_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
  ".pdf",
];

const hasAllowedExtension = (fileName: string, extensions: string[]) => {
  const lowerCasedName = fileName.toLowerCase();

  return extensions.some((extension) => lowerCasedName.endsWith(extension));
};

export const isAllowedImageFile = (file: File) =>
  IMAGE_FILE_TYPES.includes(file.type) ||
  hasAllowedExtension(file.name, IMAGE_EXTENSIONS);

export const isAllowedImageOrPdfFile = (file: File) =>
  IMAGE_FILE_TYPES.includes(file.type) ||
  file.type === "application/pdf" ||
  hasAllowedExtension(file.name, IMAGE_AND_PDF_EXTENSIONS);

export const isAllowedLessonOrResourceFile = (file: File) =>
  IMAGE_FILE_TYPES.includes(file.type) ||
  DOCUMENT_FILE_TYPES.includes(file.type) ||
  hasAllowedExtension(file.name, IMAGE_AND_DOCUMENT_EXTENSIONS);
